<template>
  <main class="about">
    <h1>About</h1>
  </main>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'About',
}
</script>
